

function Banner(){
    const bannerColor = process.env.REACT_APP_UI_BANNER_COLOR;

    return (
        <> 
        <div className={`${bannerColor} banner-stripe-thin h-1`}></div>

        <div className={`${bannerColor} banner-stripe-thin h-5 mt-1 mb-1`}></div>

        <div className={`${bannerColor} banner-stripe-thin h-1`}></div>
        </>
    )
}

export default Banner;